/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { CloudAccount } from "~/models";
import { generateActionConfirmText } from "~/tools";

type Props = {
  account: CloudAccount;
  idx: number;
  removeCallback: (idx: number) => Promise<void>;
};

function CloudAccountRemove({ account, idx, removeCallback }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  const removeAccount = React.useCallback(async () => {
    try {
      await removeCallback(idx);
    } finally {
      setIsOpen(false);
    }
  }, [removeCallback, idx]);

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        severity="low"
        onClick={() => setIsOpen(true)}
      >
        Remove
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={removeAccount}
        actionLabel="Remove"
        contentLabel="Remove cloud account"
      >
        {generateActionConfirmText(`cloud account ${account.accountName}`)(
          "remove"
        )()}{" "}
        <br />
      </ModalConfirm>
    </>
  );
}

export { CloudAccountRemove };
